module.exports = __webpack_public_path__ + "img/index_04_pic_01@2x.0bad9a21.png";